import { BetslipType } from './betslip-type';

export type LinearTypes = Record<Exclude<BetslipType, BetslipType.EditBet>, boolean>;

export const defaultLinearTypes: LinearTypes = {
    [BetslipType.Single]: false,
    [BetslipType.Combo]: false,
    [BetslipType.System]: false,
    [BetslipType.BetBuilder]: false,
    [BetslipType.Teaser]: false,
};
